<template>
  <div>
    <div class="main-content-wrapper">
      <div class="top-info">
        <div class="date-info">
          <div class="time">{{ currentTime }}</div>
          <div class="top-wd">
<!--            <div class="weekday">{{ currentWeekday }}</div>-->
            <div class="date">{{ currentDate }}</div>
          </div>
        </div>
        <div class="top-bar"><img src="@/assets/top.png" alt="头部图片" /></div>
        <div class="current-count">
          当日元气恢复人数:
          <div class="digit-container">
            <div
              v-for="(digit, index) in String(ongoingTreatmentCount || 0).padStart(3, '0')"
              :key="`digit-${index}`"
              class="digit"
            >
              {{ digit }}
            </div>
          </div>
        </div>
      </div>
      <div class="modules-wrapper" ref="modulesWrapper">
        <div
          class="frame-item"
          v-for="(item, index) in displayedAppointments"
          :key="index"
          :class="{'fade-in': item && item.isNew}"
        >
          <template v-if="item">
            <div class="top-content" :class="getTreatmentStatusClass(item)">
              <div class="room-info">
                <img :src="getTreatmentStatusIcon(item)" alt="状态图标" class="status-icon" loading="lazy" />
                {{ item.roomName }}
              </div>
              <div class="treatment-therapist-container">
                <div class="time-info">
                  {{ getTreatmentStatus(item) }} ({{ formatTimeDisplay(item.startTime) }}~{{ formatTimeDisplay(item.endTime) }})
                </div>
                <span>|</span>
                <div class="therapist-info">治疗师 : {{ formatTherapistName(item.doctorName) }}</div>
              </div>
            </div>
            <div class="main-content">
              <div class="character-section">
                <div class="character-map">
                  <img :src="getCharacterImage(item)" alt="人物图" loading="lazy" />
                  <div class="bubble-container">
                    <div v-for="bubble in item.bubbles" :key="bubble.id" class="sleep-bubble" v-show="bubble.visible" :style="{ opacity: bubble.opacity || 1, top: bubble.position && bubble.position.top, left: bubble.position && bubble.position.left, right: bubble.position && bubble.position.right, bottom: bubble.position && bubble.position.bottom }">
                      <div class="bubble-bg"></div>
                      <div class="bubble-text">+{{ bubble.value }}</div>
                    </div>
                  </div>
                </div>
                <div class="patient-huanzhe">
                  <div class="patient-name-container">
                    <img :src="item && item.patientGender === 1 ? require('@/assets/icon_male.png') : require('@/assets/icon_female.png')" class="gender-icon" alt="性别图标" loading="lazy" />
                    <span style="color: #00122E;font-weight: bold;">{{ formatPatientName(item.patientName) }}</span>
                    <div class="sleep-status" :class="{'completed-status': getTreatmentStatus(item) === '已结束', 'ongoing-status': getTreatmentStatus(item) === '治疗中'}">
                      {{ getSleepStatus(item) }}
                    </div>
                  </div>
                  <div class="bottom-content">
                    <div class="progress-container">
                      <div class="custom-progress-bar">
                        <div class="progress-track">
                          <div class="progress-fill" :style="{ width: Math.min(getProgressPercentage(item), 100) + '%' }">
                            <div class="progress-glow"></div>
                            <div class="progress-percentage">{{ getProgressPercentage(item) }}%</div>
                          </div>
                        </div>
                      </div>
                      <div class="progress-info">
                        <div class="progress-label">元气恢复进度</div>
                        <div class="progress-score">
                          <span class="score-numerator">{{ calculateEnergyScore(item) }}</span>
                          <span class="score-separator"> / </span>
                          <span class="score-denominator">{{ item.totalSeconds || 0 }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="middle-info">
                <div class="brain-waves">
                  <div class="wave-grid">
                    <div class="wave-item">
                      <div class="wave-label">Delta:</div>
                      <div class="wave-value">{{ getBrainwaveDisplay(item, 'delta') }} %</div>
                    </div>
                    <div class="wave-item">
                      <div class="wave-label">Beta:</div>
                      <div class="wave-value">{{ getBrainwaveDisplay(item, 'beta') }} %</div>
                    </div>
                    <div class="wave-item">
                      <div class="wave-label">Alpha:</div>
                      <div class="wave-value">{{ getBrainwaveDisplay(item, 'alpha') }} %</div>
                    </div>
                    <div class="wave-item">
                      <div class="wave-label">Theta:</div>
                      <div class="wave-value">{{ getBrainwaveDisplay(item, 'theta') }} %</div>
                    </div>
                    <div class="wave-item">
                      <div class="wave-label">Gamma:</div>
                      <div class="wave-value">{{ getBrainwaveDisplay(item, 'gamma') }} %</div>
                    </div>
                  </div>
                </div>
                <div class="wave-chart-wrapper">
                  <div class="wave-chart" :class="getTreatmentStatusClass(item)">
                    <div :id="'wave-chart-' + pageEpoch + '-' + (currentPage || 0) + '-' + index" :data-epoch="pageEpoch" class="echarts-container" ref="waveCharts"></div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts';
export default {
  name: 'SleepViewDefault',
  props: {
    displayedAppointments: { type: Array, default: () => [] },
    currentTime: { type: String, default: '' },
    currentWeekday: { type: String, default: '' },
    currentDate: { type: String, default: '' },
    ongoingTreatmentCount: { type: Number, default: 0 },
    isSliding: { type: Boolean, default: false },
    welcomeMessage: { type: String, default: '' },
    welcomeAnimationState: { type: String, default: '' },
    welcomeMessageStyle: { type: Object, default: () => ({}) },
    helpers: { type: Object, required: true },
    currentPage: { type: Number, default: 0 },
    pageEpoch: { type: Number, default: 0 }
  },
  data() {
    return {
      chartInstances: {},
      chartOptionCache: {},
      lastChartUpdateTime: 0,
      preloadedChartOptions: {},
      bubbleTimers: [], // 气泡动画相关 setTimeout id，组件销毁时统一清理防止内存泄漏
      chartResizeTimers: [] // 图表 resize 的 100ms setTimeout id，组件销毁时统一清理
    };
  },
  watch: {
    currentPage() {
      this.disposeAllCharts();
      this.preloadedChartOptions = {};
      this.chartOptionCache = {};
      this.$nextTick(() => {
        this.initCharts();
      });
    },
    isSliding(newVal) {
      if (newVal) {
        this.disposeAllCharts();
      }
    }
  },
  beforeDestroy() {
    if (this.bubbleTimers && this.bubbleTimers.length > 0) {
      this.bubbleTimers.forEach(id => clearTimeout(id));
      this.bubbleTimers = [];
    }
    if (this.chartResizeTimers && this.chartResizeTimers.length > 0) {
      this.chartResizeTimers.forEach(tid => clearTimeout(tid));
      this.chartResizeTimers = [];
    }
    this.chartOptionCache = {};
  },
  created() {
    this.preloadedChartOptions = {};
  },
  methods: {
    getTreatmentStatus(item) { return this.helpers.getTreatmentStatus(item) },
    getTreatmentStatusClass(item) { return this.helpers.getTreatmentStatusClass(item) },
    formatTimeDisplay(s) { return this.helpers.formatTimeDisplay(s) },
    formatTherapistName(n) { return this.helpers.formatTherapistName(n) },
    getCharacterImage(item) { return this.helpers.getCharacterImage(item) },
    calculateEnergyScore(item) { return this.helpers.calculateEnergyScore(item) },
    getBrainwaveDisplay(item, type) { return this.helpers.getBrainwaveDisplay(item, type) },
    getTreatmentStatusIcon(item) { return this.helpers.getTreatmentStatusIcon(item) },
    getSleepStatus(item) { return this.helpers.getSleepStatus(item) },
    getProgressPercentage(item) { return this.helpers.getProgressPercentage(item) },
    formatPatientName(n) { return this.helpers.formatPatientName(n) },
    // 压缩 waveData 的辅助方法
    compressWaveData(data, targetLength) {
      if (!data || !Array.isArray(data) || data.length === 0) {
        return [];
      }
      
      if (data.length <= targetLength) {
        return data.map(item => {
          if (typeof item === 'object' && item !== null) {
            return { ...item };
          }
          return item;
        });
      }
      
      // 提取数值用于查找最大值和最小值
      const values = data.map(point => {
        if (typeof point === 'object' && point !== null) {
          return point.value !== undefined ? point.value : point;
        }
        return point;
      });
      
      // 使用与 getChartOption 中相同的压缩算法
      const indices = new Set();
      indices.add(0); // 起始点
      indices.add(data.length - 1); // 结束点
      
      // 找到最大值和最小值
      let maxIndex = 0;
      let minIndex = 0;
      let maxValue = values[0];
      let minValue = values[0];
      
      for (let i = 1; i < values.length; i++) {
        if (values[i] > maxValue) {
          maxValue = values[i];
          maxIndex = i;
        }
        if (values[i] < minValue) {
          minValue = values[i];
          minIndex = i;
        }
      }
      
      if (maxIndex !== 0 && maxIndex !== data.length - 1) {
        indices.add(maxIndex);
      }
      if (minIndex !== 0 && minIndex !== data.length - 1 && minIndex !== maxIndex) {
        indices.add(minIndex);
      }
      
      // 均匀采样剩余的点
      const remainingPoints = targetLength - indices.size;
      if (remainingPoints > 0) {
        const step = (data.length - 1) / (remainingPoints + 1);
        for (let i = 0; i < remainingPoints; i++) {
          let candidateIndex = Math.round((i + 1) * step);
          
          if (indices.has(candidateIndex)) {
            let offset = 1;
            while (candidateIndex + offset < data.length && indices.has(candidateIndex + offset)) {
              offset++;
            }
            if (candidateIndex + offset < data.length) {
              candidateIndex = candidateIndex + offset;
            } else {
              offset = -1;
              while (candidateIndex + offset >= 0 && indices.has(candidateIndex + offset)) {
                offset--;
              }
              if (candidateIndex + offset >= 0) {
                candidateIndex = candidateIndex + offset;
              }
            }
          }
          
          indices.add(candidateIndex);
        }
      }
      
      // 排序并提取
      const sortedIndices = Array.from(indices).sort((a, b) => a - b);
      const finalIndices = sortedIndices.slice(0, targetLength);
      
      // 确保起始点和结束点
      if (finalIndices[0] !== 0) {
        finalIndices[0] = 0;
      }
      if (finalIndices[finalIndices.length - 1] !== data.length - 1) {
        finalIndices[finalIndices.length - 1] = data.length - 1;
      }
      
      const uniqueIndices = [...new Set(finalIndices)].sort((a, b) => a - b);
      
      return uniqueIndices.map(index => {
        const originalItem = data[index];
        if (typeof originalItem === 'object' && originalItem !== null) {
          return { ...originalItem };
        }
        return originalItem;
      });
    },
    preloadChartOptions(items) {
      if (!Array.isArray(items)) return;
      // 每次预加载前先清空，确保不会拿到上一页的配置
      this.preloadedChartOptions = {};
      items.forEach((item, index) => {
        if (!item) return;
        const option = this.getChartOption(item);
        this.$set(this.preloadedChartOptions, index, option);
      });
    },
    updateSinglePatientBubble(patient) {
      if (!patient) return;
      const now = Date.now();
      if (!patient.bubbles) {
        this.$set(patient, 'bubbles', []);
      }
      if (!patient.lastBubbleTime) {
        this.$set(patient, 'lastBubbleTime', 0);
      }
      const treatmentStatus = this.getTreatmentStatus(patient);
      if (treatmentStatus === '已结束') {
        return;
      }
      const sleepStatus = this.getSleepStatus(patient);
      const bubbleValue = patient.lastAddedScore || (this.helpers.getSleepBubbleValue ? this.helpers.getSleepBubbleValue(sleepStatus) : 0);
      patient.lastAddedScore = undefined;
      if (bubbleValue >= 0) {
        patient.lastBubbleTime = now;
        const positions = [
          { top: '60px', left: '10px' },
          { top: '60px', right: '10px' },
          { top: '60px', left: '20px' },
          { top: '60px', right: '30px' },
          { top: '60px', left: '30px' },
          { top: '60px', right: '20px' }
        ];
        let availablePositions = [...positions];
        if (patient.bubbles.length > 0) {
          const existingPositions = patient.bubbles.map(b => JSON.stringify(b.position));
          availablePositions = positions.filter(pos => !existingPositions.includes(JSON.stringify(pos)));
        }
        const randomPosition = availablePositions.length > 0 
          ? availablePositions[Math.floor(Math.random() * availablePositions.length)]
          : positions[Math.floor(Math.random() * positions.length)];
        if (this.helpers.addSystemLog) {
          this.helpers.addSystemLog(`${patient.roomName} - ${patient.patientName} 产生${sleepStatus}气泡 +${bubbleValue}`);
        }
        const jitterDelay = Math.floor(Math.random() * 500);
        const newBubble = {
          id: `${now}-${Math.floor(Math.random() * 10000)}-${patient.roomName}-${patient.patientName}`,
          type: sleepStatus,
          value: bubbleValue,
          visible: true,
          opacity: 0,
          position: randomPosition
        };
        const t1 = setTimeout(() => {
          const bubbleIndex = patient.bubbles.length;
          this.$set(patient.bubbles, bubbleIndex, newBubble);
          const t2 = setTimeout(() => {
            const index = patient.bubbles.findIndex(b => b.id === newBubble.id);
            if (index !== -1) {
              this.$set(patient.bubbles[index], 'opacity', 1);
            }
          }, 100);
          this.bubbleTimers.push(t2);
          const t3 = setTimeout(() => {
            const index = patient.bubbles.findIndex(b => b.id === newBubble.id);
            if (index !== -1) {
              this.$delete(patient.bubbles, index);
            }
          }, 4000);
          this.bubbleTimers.push(t3);
        }, jitterDelay);
        this.bubbleTimers.push(t1);
      }
    },
    updateBubbles() {
      if (this.isSliding) return;
      // epoch 校验：获取当前 epoch 快照，如果变化则返回
      const epochSnap = this.pageEpoch;
      const now = Date.now();
      // 修复气泡问题：确保只处理当前页面的患者
      // displayedAppointments 应该只包含当前页面的患者，但为了安全起见，再次过滤
      const currentPageAppointments = (this.displayedAppointments || []).filter(item => item !== null);
      if (currentPageAppointments && currentPageAppointments.length > 0) {
        // 限制只处理当前页面的患者（最多4个或2个，取决于是否有欢迎语）
        // 注意：这里需要通过props获取welcomeMessage，但SleepViewDefault可能没有这个prop
        // 所以默认使用4个，如果有欢迎语，父组件应该传递正确的值
        const maxBubblesPerPage = 4; // 默认每页最多4个患者
        const limitedAppointments = currentPageAppointments.slice(0, maxBubblesPerPage);
        
        limitedAppointments.forEach((item, index) => {
          // epoch 校验：在处理每个患者前，再次检查 epoch 是否变化
          if (this.pageEpoch !== epochSnap) {
            return;
          }
          // 验证患者对应的容器是否仍在文档中且 epoch 匹配
          const pageIndex = this.currentPage || 0;
          const containerId = `wave-chart-${epochSnap}-${pageIndex}-${index}`;
          const container = document.getElementById(containerId);
          if (!container || +container.dataset.epoch !== epochSnap) {
            return;
          }
          if (!item.bubbles) {
            this.$set(item, 'bubbles', []);
          }
          // 清理过期气泡（超过 5 秒），防止内存泄漏和堆积
          if (item.bubbles && item.bubbles.length > 0) {
            const currentTime = Date.now();
            item.bubbles = item.bubbles.filter(bubble => {
              // 从气泡 ID 中提取时间戳（格式：timestamp-随机数-...）
              if (!bubble.id) return false;
              const idParts = bubble.id.split('-');
              const bubbleTime = parseInt(idParts[0]) || 0;
              // 保留 5 秒内的气泡（比 4 秒销毁时间稍长，确保已过销毁时间）
              return (currentTime - bubbleTime) < 5000;
            });
            
            // 限制数组最大长度为 10，防止异常情况下无限增长
            if (item.bubbles.length > 10) {
              item.bubbles = item.bubbles.slice(-10); // 保留最新的 10 个
            }
          }
          if (!item.lastBubbleTime) {
            this.$set(item, 'lastBubbleTime', 0);
          }
          const treatmentStatus = this.getTreatmentStatus(item);
          if (treatmentStatus === '已结束') {
            return;
          }
          // 限制每个患者同时最多显示 2 个气泡
          if (item.bubbles.length >= 2) {
            return;
          }
          // 增加生成间隔到 4 秒，避免气泡生成过于频繁
          if (now - item.lastBubbleTime < 4000 && item.bubbles.length > 0) {
            return;
          }
          const sleepStatus = this.getSleepStatus(item);
          const bubbleValue = item.lastAddedScore || (this.helpers.getSleepBubbleValue ? this.helpers.getSleepBubbleValue(sleepStatus) : 0);
          item.lastAddedScore = undefined;
          if (bubbleValue >= 0) {
            item.lastBubbleTime = now;
            const positions = [
              { top: '60px', left: '10px' },
              { top: '60px', right: '10px' },
              { top: '60px', left: '20px' },
              { top: '60px', right: '30px' },
              { top: '60px', left: '30px' },
              { top: '60px', right: '20px' }
            ];
            let availablePositions = [...positions];
            if (item.bubbles.length > 0) {
              const existingPositions = item.bubbles.map(b => JSON.stringify(b.position));
              availablePositions = positions.filter(pos => !existingPositions.includes(JSON.stringify(pos)));
            }
            const randomPosition = availablePositions.length > 0 
              ? availablePositions[Math.floor(Math.random() * availablePositions.length)]
              : positions[Math.floor(Math.random() * positions.length)];
            if (this.helpers.addSystemLog) {
              this.helpers.addSystemLog(`${item.roomName} - ${item.patientName} 产生${sleepStatus}气泡 +${bubbleValue}`);
            }
            const jitterDelay = Math.floor(Math.random() * 500);
            const newBubble = {
              id: `${now}-${Math.floor(Math.random() * 10000)}-${item.roomName}-${item.patientName}`,
              type: sleepStatus,
              value: bubbleValue,
              visible: true,
              opacity: 0,
              position: randomPosition
            };
            const t1 = setTimeout(() => {
              const bubbleIndex = item.bubbles.length;
              this.$set(item.bubbles, bubbleIndex, newBubble);
              const t2 = setTimeout(() => {
                const index = item.bubbles.findIndex(b => b.id === newBubble.id);
                if (index !== -1) {
                  this.$set(item.bubbles[index], 'opacity', 1);
                }
              }, 100);
              this.bubbleTimers.push(t2);
              const t3 = setTimeout(() => {
                const index = item.bubbles.findIndex(b => b.id === newBubble.id);
                if (index !== -1) {
                  this.$delete(item.bubbles, index);
                }
              }, 4000);
              this.bubbleTimers.push(t3);
            }, jitterDelay);
            this.bubbleTimers.push(t1);
          }
        });
      }
    },
    initCharts() {
      this.$nextTick(() => {
        this.lastChartUpdateTime = 0;
        // 先清理所有不在当前页面的图表
        this.cleanupOffPageCharts();
        
        // 获取当前 epoch 快照，用于校验
        const epochSnap = this.pageEpoch;
        (this.displayedAppointments || []).forEach((item, index) => {
          // epoch 校验：在处理每个图表前，检查 epoch 是否变化
          if (this.pageEpoch !== epochSnap) {
            return;
          }
          if (!item) return;
          
          // 确保 waveData 存在且不会被清空（除非治疗已结束）
          // 这是关键：轮播切换时，历史数据必须保留
          const treatmentStatus = this.getTreatmentStatus(item);
          if (treatmentStatus !== '已结束') {
            // 关键修复：在初始化图表前，检查并恢复waveData
            // 如果item的waveData为空或不存在，尝试从appointmentData中恢复
            const hasWaveData = item.waveData && (
              (item.waveData.delta && item.waveData.delta.length > 0) ||
              (item.waveData.theta && item.waveData.theta.length > 0) ||
              (item.waveData.alpha && item.waveData.alpha.length > 0) ||
              (item.waveData.beta && item.waveData.beta.length > 0) ||
              (item.waveData.gamma && item.waveData.gamma.length > 0)
            );
            
            if (!hasWaveData && this.$parent && this.$parent.appointmentData) {
              // 尝试从父组件的appointmentData中查找相同roomId的项并恢复waveData
              const sourceItem = this.$parent.appointmentData.find(app => 
                app.roomId && item.roomId && 
                app.roomId.toString() === item.roomId.toString() &&
                app.waveData && (
                  (app.waveData.delta && app.waveData.delta.length > 0) ||
                  (app.waveData.theta && app.waveData.theta.length > 0) ||
                  (app.waveData.alpha && app.waveData.alpha.length > 0) ||
                  (app.waveData.beta && app.waveData.beta.length > 0) ||
                  (app.waveData.gamma && app.waveData.gamma.length > 0)
                )
              );
              
              if (sourceItem && sourceItem.waveData) {
                // 从sourceItem恢复waveData（深拷贝）
                this.$set(item, 'waveData', {
                  delta: sourceItem.waveData.delta ? [...sourceItem.waveData.delta.map(d => ({ ...d }))] : [],
                  theta: sourceItem.waveData.theta ? [...sourceItem.waveData.theta.map(d => ({ ...d }))] : [],
                  alpha: sourceItem.waveData.alpha ? [...sourceItem.waveData.alpha.map(d => ({ ...d }))] : [],
                  beta: sourceItem.waveData.beta ? [...sourceItem.waveData.beta.map(d => ({ ...d }))] : [],
                  gamma: sourceItem.waveData.gamma ? [...sourceItem.waveData.gamma.map(d => ({ ...d }))] : []
                });
                console.log(`[initCharts恢复] ✓ 房间 ${item.roomId}: 从appointmentData恢复了waveData`, {
                  roomId: item.roomId,
                  waveDataLengths: {
                    delta: item.waveData.delta.length,
                    theta: item.waveData.theta.length,
                    alpha: item.waveData.alpha.length,
                    beta: item.waveData.beta.length,
                    gamma: item.waveData.gamma.length
                  }
                });
              }
            }
            
            if (!item.waveData) {
              // 如果治疗未结束但没有 waveData，初始化空数组
              this.$set(item, 'waveData', {
                delta: [],
                theta: [],
                alpha: [],
                beta: [],
                gamma: []
              });
            } else {
              // 确保 waveData 的每个数组都存在
              ['delta', 'theta', 'alpha', 'beta', 'gamma'].forEach(type => {
                if (!item.waveData[type] || !Array.isArray(item.waveData[type])) {
                  this.$set(item.waveData, type, []);
                }
              });
            }
          }
          
          // 使用 epoch、页面号和索引生成唯一ID，防止不同页面的图表冲突
          const pageIndex = this.currentPage || 0;
          const chartId = `wave-chart-${epochSnap}-${pageIndex}-${index}`;
          const chartDom = document.getElementById(chartId);
          // epoch 校验：确保容器存在且 epoch 匹配
          if (!chartDom || +chartDom.dataset.epoch !== epochSnap) return;
          
          // 如果已存在实例，先清理
          if (this.chartInstances[chartId]) {
            try {
              this.chartInstances[chartId].dispose();
            } catch (e) {
              // 忽略错误
            }
          }
          
          const chart = echarts.init(chartDom);
          this.chartInstances[chartId] = chart;
          const pre = this.preloadedChartOptions && this.preloadedChartOptions[index];
          const option = pre ? pre : this.getChartOption(item);
          
          // 关键修复：记录图表初始化时的数据状态，确保轮播切换后能正确恢复波线
          const hasHistoryDataOnInit = (item.waveData && (
            (item.waveData.delta && item.waveData.delta.length > 0) ||
            (item.waveData.theta && item.waveData.theta.length > 0) ||
            (item.waveData.alpha && item.waveData.alpha.length > 0) ||
            (item.waveData.beta && item.waveData.beta.length > 0) ||
            (item.waveData.gamma && item.waveData.gamma.length > 0)
          ));
          
          if (hasHistoryDataOnInit) {
            console.log(`[initCharts] 初始化图表 ${chartId}，检测到历史波线数据`, {
              roomId: item.roomId,
              waveDataLengths: {
                delta: item.waveData.delta?.length || 0,
                theta: item.waveData.theta?.length || 0,
                alpha: item.waveData.alpha?.length || 0,
                beta: item.waveData.beta?.length || 0,
                gamma: item.waveData.gamma?.length || 0
              },
              seriesCount: option.series?.length || 0,
              hasRealtimeArray: !!(item.realtimeDataArray && item.realtimeDataArray.length > 0),
              hasLastValid: !!item.lastValidBrainwaveData
            });
          }
          
          // 首次初始化必须立即同步 setOption 完整 option（含 xAxis/yAxis/grid）
          // 不能延迟到 rAF，否则 ECharts 在 init 后会立即尝试渲染，但此时还没有坐标系，导致 xAxis not found
          chart.setOption(option, { notMerge: true, lazyUpdate: false, silent: true });
          const tid = setTimeout(() => { chart.resize(); }, 100);
          this.chartResizeTimers.push(tid);
          if (pre) {
            delete this.preloadedChartOptions[index];
          }
        });
      });
    },
    initChart(index, item) {
      const epochSnap = this.pageEpoch;
      const pageIndex = this.currentPage || 0;
      const chartId = `wave-chart-${epochSnap}-${pageIndex}-${index}`;
      const chartDom = document.getElementById(chartId);
      // epoch 校验：确保容器存在且 epoch 匹配
      if (!chartDom || +chartDom.dataset.epoch !== epochSnap) return;
      
      // 如果已存在实例，先清理
      if (this.chartInstances[chartId]) {
        try {
          this.chartInstances[chartId].dispose();
        } catch (e) {
          // 忽略错误
        }
      }
      
      const chart = echarts.init(chartDom);
      this.chartInstances[chartId] = chart;
      const option = this.getChartOption(item);
      this.chartOptionCache[chartId] = option;
      // 首次初始化：必须立即同步 setOption 完整 option（含 xAxis/yAxis/grid）
      // 不能延迟到 rAF，否则 ECharts 在 init 后会立即尝试渲染，但此时还没有坐标系，导致 xAxis not found
      chart.setOption(option, { notMerge: true, lazyUpdate: false, silent: true });
      const tid = setTimeout(() => { chart.resize(); }, 100);
      this.chartResizeTimers.push(tid);
    },
    cleanupOffPageCharts() {
      // 清理所有不在当前页面或不属于当前 epoch 的图表实例
      const currentPageIndex = this.currentPage || 0;
      const currentEpoch = this.pageEpoch;
      Object.keys(this.chartInstances).forEach(id => {
        // 检查图表ID是否属于当前页面和当前 epoch
        // 新格式：wave-chart-{epoch}-{pageIndex}-{index}
        const match = id.match(/wave-chart-(\d+)-(\d+)-(\d+)/);
        if (match) {
          const epoch = parseInt(match[1]);
          const pageIndex = parseInt(match[2]);
          // 清理不属于当前 epoch 或当前页面的图表
          if (epoch !== currentEpoch || pageIndex !== currentPageIndex) {
            // 不属于当前页面，清理
            const chart = this.chartInstances[id];
            if (chart) {
              try {
                // 移除 clear()，直接 dispose，避免闪烁
                chart.dispose();
              } catch (e) {
                // 忽略错误
              }
            }
            delete this.chartInstances[id];
            
            // 清理DOM元素
            const el = document.getElementById(id);
            if (el) {
              el.innerHTML = '';
              const canvasElements = el.querySelectorAll('canvas');
              canvasElements.forEach(canvas => {
                try {
                  canvas.remove();
                } catch (e) {
                  // 忽略错误
                }
              });
            }
          }
        }
      });
    },
    getChartOption(item) {
      if (this.getTreatmentStatus(item) === '已结束') {
        return {
          backgroundColor: 'transparent',
          grid: { top: 10, right: 10, bottom: 10, left: 10, containLabel: false },
          xAxis: { type: 'category', data: [], show: false },
          yAxis: { type: 'value', show: false },
          series: [],
          animation: false
        };
      }
      
      const waveData = item.waveData || { delta: [], theta: [], alpha: [], beta: [], gamma: [] };
      
      // 关键修复：检查当前脑波值，如果为 undefined，尝试从 lastValidBrainwaveData 恢复
      // 避免将 undefined 错误转换为 0
      let delta = item.delta;
      let theta = item.theta;
      let alpha = item.alpha;
      let beta = item.beta;
      let gamma = item.gamma;
      
      // 如果值为 undefined，尝试从 lastValidBrainwaveData 恢复
      if (item.lastValidBrainwaveData) {
        if (delta === undefined || delta === null) delta = item.lastValidBrainwaveData.delta;
        if (theta === undefined || theta === null) theta = item.lastValidBrainwaveData.theta;
        if (alpha === undefined || alpha === null) alpha = item.lastValidBrainwaveData.alpha;
        if (beta === undefined || beta === null) beta = item.lastValidBrainwaveData.beta;
        if (gamma === undefined || gamma === null) gamma = item.lastValidBrainwaveData.gamma;
      }
      
      // 关键修复：只有在所有值都明确为 0 时才判断为全0（不包括 undefined）
      // 如果值为 undefined，说明数据可能丢失，不应该判断为全0
      const currentAllZero = (delta === 0 || delta === undefined) && 
                            (theta === 0 || theta === undefined) && 
                            (alpha === 0 || alpha === undefined) && 
                            (beta === 0 || beta === undefined) && 
                            (gamma === 0 || gamma === undefined) &&
                            delta !== undefined && theta !== undefined && alpha !== undefined && beta !== undefined && gamma !== undefined;
      
      // 检查历史数据是否存在
      const hasHistoryData = (waveData.delta && waveData.delta.length > 0) ||
                            (waveData.theta && waveData.theta.length > 0) ||
                            (waveData.alpha && waveData.alpha.length > 0) ||
                            (waveData.beta && waveData.beta.length > 0) ||
                            (waveData.gamma && waveData.gamma.length > 0);
      
      // 关键修复：检查是否有真实的脑波数据源
      // 优先级：1. 有历史数据（waveData）优先，2. 有实时数据数组，3. 有最后有效数据
      // 排除虚拟数据（isMock）
      const isRealData = !item.isMock;
      
      // 1. 检查是否有 realtimeDataArray（表示接收过实时数据）
      const hasRealtimeDataArray = item.realtimeDataArray && Array.isArray(item.realtimeDataArray) && item.realtimeDataArray.length > 0;
      
      // 2. 关键修复：对于虚拟数据和真实数据，都优先使用lastValidBrainwaveData判断
      // 对于真实数据，如果脑波值为0/undefined但存在lastValidBrainwaveData（可能是生成的虚拟数据），也应该认为有数据源
      let hasValidLastValidData = false;
      if (item.lastValidBrainwaveData) {
        // 无论是虚拟数据还是真实数据，都检查lastValidBrainwaveData
        hasValidLastValidData = (item.lastValidBrainwaveData.delta > 0 || 
                                 item.lastValidBrainwaveData.theta > 0 ||
                                 item.lastValidBrainwaveData.alpha > 0 ||
                                 item.lastValidBrainwaveData.beta > 0 ||
                                 item.lastValidBrainwaveData.gamma > 0);
      }
      
      // 2.5. 检查模拟数据是否有脑波值（模拟数据只要有脑波值就显示，不需要其他条件）
      // 关键修复：对于虚拟数据，如果lastValidBrainwaveData存在且有效，也应该认为有脑波值
      const hasMockBrainwaveValues = !isRealData && (
        hasValidLastValidData || // 优先使用lastValidBrainwaveData
        (delta !== undefined && delta !== null && delta > 0) ||
        (theta !== undefined && theta !== null && theta > 0) ||
        (alpha !== undefined && alpha !== null && alpha > 0) ||
        (beta !== undefined && beta !== null && beta > 0) ||
        (gamma !== undefined && gamma !== null && gamma > 0)
      );
      
      // 真实数据：仅当存在真实脑波数据源（realtimeDataArray）时才展示脑波；虚拟数据：沿用 hasHistoryData、hasValidLastValidData、hasMockBrainwaveValues
      const hasRealBrainwaveDataSource = isRealData
        ? hasRealtimeDataArray
        : (hasHistoryData || hasValidLastValidData || hasMockBrainwaveValues);
      
      const treatmentStatus = this.getTreatmentStatus(item);
      const isTreatmentEnded = treatmentStatus === '已结束';
      
      // 关键修复：只有在有真实数据源时才显示波线
      // 如果没有真实数据源，即使治疗中也返回空配置
      if (!hasRealBrainwaveDataSource) {
        console.log(`getChartOption: 返回空配置 - 没有真实的脑波数据源`, {
          roomId: item.roomId,
          isMock: item.isMock,
          hasRealtimeDataArray,
          hasValidLastValidData,
          hasHistoryData,
          currentValues: { delta, theta, alpha, beta, gamma },
          治疗状态: treatmentStatus
        });
        return {
          backgroundColor: 'transparent',
          grid: { top: 10, right: 10, bottom: 10, left: 10, containLabel: false },
          xAxis: { type: 'category', data: [], show: false },
          yAxis: { type: 'value', show: false },
          series: [],
          animation: false
        };
      }
      
      // 如果治疗已结束且无历史数据，返回空配置
      // 对于虚拟数据，即使治疗结束，只要有历史数据或脑波值就显示
      const shouldShowForMock = !isRealData && (hasHistoryData || hasMockBrainwaveValues);
      if (isTreatmentEnded && !hasHistoryData && currentAllZero && !shouldShowForMock) {
        // 调试日志：记录为什么返回空配置
        console.log(`getChartOption: 返回空配置 - 治疗已结束且无历史数据`, {
          roomId: item.roomId,
          isMock: item.isMock,
          currentValues: { delta, theta, alpha, beta, gamma },
          waveDataLengths: {
            delta: waveData.delta?.length || 0,
            theta: waveData.theta?.length || 0,
            alpha: waveData.alpha?.length || 0,
            beta: waveData.beta?.length || 0,
            gamma: waveData.gamma?.length || 0
          },
          治疗状态: treatmentStatus,
          shouldShowForMock
        });
        return {
          backgroundColor: 'transparent',
          grid: { top: 10, right: 10, bottom: 10, left: 10, containLabel: false },
          xAxis: { type: 'category', data: [], show: false },
          yAxis: { type: 'value', show: false },
          series: [],
          animation: false
        };
      }
      
      // 关键修复：如果有真实数据源，即使当前值为0，也要显示波线
      // 这是用户的核心需求：波线一直展示，无论轮播几次，直到治疗结束
      if (hasRealBrainwaveDataSource) {
        console.log(`getChartOption: 有真实脑波数据源，将显示波线`, {
          roomId: item.roomId,
          isMock: item.isMock,
          hasRealtimeDataArray,
          hasValidLastValidData,
          hasHistoryData,
          currentValues: { delta, theta, alpha, beta, gamma },
          currentAllZero,
          waveDataLengths: {
            delta: waveData.delta?.length || 0,
            theta: waveData.theta?.length || 0,
            alpha: waveData.alpha?.length || 0,
            beta: waveData.beta?.length || 0,
            gamma: waveData.gamma?.length || 0
          },
          治疗状态: treatmentStatus
        });
        // 继续执行，显示波线
      }
      
      // 调试日志：记录数据读取情况
      if (hasHistoryData) {
        console.log(`getChartOption: 有历史数据，将显示历史波线`, {
          roomId: item.roomId,
          currentValues: { delta, theta, alpha, beta, gamma },
          waveDataLengths: {
            delta: waveData.delta?.length || 0,
            theta: waveData.theta?.length || 0,
            alpha: waveData.alpha?.length || 0,
            beta: waveData.beta?.length || 0,
            gamma: waveData.gamma?.length || 0
          },
          currentAllZero
        });
      }
      // 计算最大数据长度，确保能显示所有历史数据
      const maxDataLength = Math.max(
        waveData.delta?.length || 0,
        waveData.theta?.length || 0,
        waveData.alpha?.length || 0,
        waveData.beta?.length || 0,
        waveData.gamma?.length || 0,
        50
      );
      
      // 优化容器宽度：使用实际容器宽度（400px），增加可显示的数据点数
      const containerWidth = 400; // 从CSS中看到实际宽度是400px
      const maxDisplayPoints = Math.floor(containerWidth / 1.2); // 减小间距，增加可显示点数（约333个点）
      
      // 优化后的数据压缩函数：智能采样，保留关键特征点（最大值、最小值、起始点、结束点）
      const compressData = (data, targetLength) => {
        if (!data || !Array.isArray(data) || data.length === 0) {
          return [];
        }
        
        // 如果数据量小于等于目标长度，返回所有数据
        if (data.length <= targetLength) {
          return data.map(point => {
            if (typeof point === 'object' && point !== null) {
              return point.value !== undefined ? point.value : point;
            }
            return point;
          });
        }
        
        // 提取数值
        const values = data.map(point => {
          if (typeof point === 'object' && point !== null) {
            return point.value !== undefined ? point.value : point;
          }
          return point;
        });
        
        // 智能压缩算法：
        // 1. 保留起始点和结束点
        // 2. 保留最大值和最小值点
        // 3. 在剩余空间中均匀采样
        const result = [];
        const indices = new Set(); // 使用Set避免重复索引
        
        // 1. 保留起始点
        indices.add(0);
        // 2. 保留结束点
        indices.add(data.length - 1);
        
        // 3. 找到最大值和最小值的索引
        let maxIndex = 0;
        let minIndex = 0;
        let maxValue = values[0];
        let minValue = values[0];
        
        for (let i = 1; i < values.length; i++) {
          if (values[i] > maxValue) {
            maxValue = values[i];
            maxIndex = i;
          }
          if (values[i] < minValue) {
            minValue = values[i];
            minIndex = i;
          }
        }
        
        // 只有当最大值和最小值点与起始/结束点不同时才添加
        if (maxIndex !== 0 && maxIndex !== data.length - 1) {
          indices.add(maxIndex);
        }
        if (minIndex !== 0 && minIndex !== data.length - 1 && minIndex !== maxIndex) {
          indices.add(minIndex);
        }
        
        // 4. 计算剩余需要的点数
        const remainingPoints = targetLength - indices.size;
        if (remainingPoints > 0) {
          // 5. 均匀采样剩余的点（排除已经选择的关键点）
          const step = (data.length - 1) / (remainingPoints + 1);
          for (let i = 0; i < remainingPoints; i++) {
            let candidateIndex = Math.round((i + 1) * step);
            
            // 如果候选索引已经被选择，尝试前后偏移
            if (indices.has(candidateIndex)) {
              // 尝试向后查找
              let offset = 1;
              while (candidateIndex + offset < data.length && indices.has(candidateIndex + offset)) {
                offset++;
              }
              if (candidateIndex + offset < data.length) {
                candidateIndex = candidateIndex + offset;
              } else {
                // 如果向后不行，尝试向前
                offset = -1;
                while (candidateIndex + offset >= 0 && indices.has(candidateIndex + offset)) {
                  offset--;
                }
                if (candidateIndex + offset >= 0) {
                  candidateIndex = candidateIndex + offset;
                }
              }
            }
            
            indices.add(candidateIndex);
          }
        }
        
        // 6. 将索引排序并提取对应的值
        const sortedIndices = Array.from(indices).sort((a, b) => a - b);
        // 如果排序后的索引数量超过目标长度，保留前targetLength个
        const finalIndices = sortedIndices.slice(0, targetLength);
        
        // 确保起始点和结束点被包含
        if (finalIndices[0] !== 0) {
          finalIndices[0] = 0;
        }
        if (finalIndices[finalIndices.length - 1] !== data.length - 1) {
          finalIndices[finalIndices.length - 1] = data.length - 1;
        }
        
        // 去重并排序
        const uniqueIndices = [...new Set(finalIndices)].sort((a, b) => a - b);
        
        return uniqueIndices.map(index => values[index]);
      };
      
      // 获取显示数据：使用压缩算法确保所有历史数据都能显示
      const getLatestData = (data) => {
        if (!data || !Array.isArray(data) || data.length === 0) {
          return [];
        }
        
        // 如果数据量小于等于显示点数，返回所有数据
        if (data.length <= maxDisplayPoints) {
          return data.map(point => {
            if (typeof point === 'object' && point !== null) {
              return point.value !== undefined ? point.value : point;
            }
            return point;
          });
        }
        
        // 如果数据量大于显示点数，使用压缩算法
        // 关键修复：压缩所有历史数据，而不是只取最新的数据点
        return compressData(data, maxDisplayPoints);
      };
      
      // 计算实际显示长度（压缩后的数据长度）
      const displayLength = Math.min(maxDataLength, maxDisplayPoints);
      const xAxisData = Array.from({ length: displayLength }, (_, i) => i);
      
      // 构建series数组，只包含有数据的波线
      const series = [];
      // 修复波线过于平整问题：降低smooth程度，从true改为0.3，让波线有更多起伏
      if (waveData.delta && waveData.delta.length > 0) {
        series.push({ name: 'Delta', type: 'line', data: getLatestData(waveData.delta), smooth: 0.3, symbol: 'none', lineStyle: { color: '#FF5722', width: 1 } });
      }
      if (waveData.theta && waveData.theta.length > 0) {
        series.push({ name: 'Theta', type: 'line', data: getLatestData(waveData.theta), smooth: 0.3, symbol: 'none', lineStyle: { color: '#FFEB3B', width: 1 } });
      }
      if (waveData.alpha && waveData.alpha.length > 0) {
        series.push({ name: 'Alpha', type: 'line', data: getLatestData(waveData.alpha), smooth: 0.3, symbol: 'none', lineStyle: { color: '#4CAF50', width: 1 } });
      }
      if (waveData.beta && waveData.beta.length > 0) {
        series.push({ name: 'Beta', type: 'line', data: getLatestData(waveData.beta), smooth: 0.3, symbol: 'none', lineStyle: { color: '#2196F3', width: 1 } });
      }
      if (waveData.gamma && waveData.gamma.length > 0) {
        series.push({ name: 'Gamma', type: 'line', data: getLatestData(waveData.gamma), smooth: 0.3, symbol: 'none', lineStyle: { color: '#9C27B0', width: 1 } });
      }
      
      return {
        backgroundColor: 'transparent',
        grid: { top: 10, right: 10, bottom: 10, left: 10, containLabel: false },
        xAxis: { type: 'category', data: xAxisData, show: false },
        yAxis: { type: 'value', show: false },
        series: series,
        animation: false
      };
    },
    updateAllCharts() {
      if (this.isSliding) return;
      // epoch 校验：获取当前 epoch 快照，如果变化则返回
      const epochSnap = this.pageEpoch;
      // 修复波线穿透问题：确保只更新当前页面的图表
      const currentPageIndex = this.currentPage || 0;
      (this.displayedAppointments || []).forEach((item, index) => {
        // epoch 校验：在处理每个图表前，检查 epoch 是否变化
        if (this.pageEpoch !== epochSnap) {
          return;
        }
        if (!item) return;
        
        // 检查当前脑波值是否都为0
        const delta = item.delta || 0;
        const theta = item.theta || 0;
        const alpha = item.alpha || 0;
        const beta = item.beta || 0;
        const gamma = item.gamma || 0;
        const currentAllZero = delta === 0 && theta === 0 && alpha === 0 && beta === 0 && gamma === 0;
        
        // 检查历史数据是否存在
        const waveData = item.waveData || { delta: [], theta: [], alpha: [], beta: [], gamma: [] };
        const hasHistoryData = (waveData.delta && waveData.delta.length > 0) ||
                              (waveData.theta && waveData.theta.length > 0) ||
                              (waveData.alpha && waveData.alpha.length > 0) ||
                              (waveData.beta && waveData.beta.length > 0) ||
                              (waveData.gamma && waveData.gamma.length > 0);
        
        // 关键修复：检查是否有真实的脑波数据源
        // 优先级：1. 有历史数据（waveData）优先，2. 有实时数据数组，3. 有最后有效数据
        // 排除虚拟数据（isMock）
        const isRealData = !item.isMock;
        
        // 1. 检查是否有 realtimeDataArray（表示接收过实时数据）
        const hasRealtimeDataArray = item.realtimeDataArray && Array.isArray(item.realtimeDataArray) && item.realtimeDataArray.length > 0;
        
        // 2. 检查是否有 lastValidBrainwaveData 且有有效值
        const hasValidLastValidData = item.lastValidBrainwaveData && 
                                     (item.lastValidBrainwaveData.delta > 0 || 
                                      item.lastValidBrainwaveData.theta > 0 ||
                                      item.lastValidBrainwaveData.alpha > 0 ||
                                      item.lastValidBrainwaveData.beta > 0 ||
                                      item.lastValidBrainwaveData.gamma > 0);
        
        // 2.5. 检查模拟数据是否有脑波值（模拟数据只要有脑波值就显示，不需要其他条件）
        const hasMockBrainwaveValues = !isRealData && (
          (delta !== undefined && delta !== null && delta > 0) ||
          (theta !== undefined && theta !== null && theta > 0) ||
          (alpha !== undefined && alpha !== null && alpha > 0) ||
          (beta !== undefined && beta !== null && beta > 0) ||
          (gamma !== undefined && gamma !== null && gamma > 0)
        );
        
        // 真实数据仅认 realtimeDataArray；虚拟数据沿用 hasHistoryData、hasValidLastValidData、hasMockBrainwaveValues
        const hasRealBrainwaveDataSource = isRealData
          ? hasRealtimeDataArray
          : (hasHistoryData || hasValidLastValidData || hasMockBrainwaveValues);
        
        // 检查治疗状态
        const treatmentStatus = this.getTreatmentStatus(item);
        const isTreatmentEnded = treatmentStatus === '已结束';
        
        // 关键修复：只有在有真实数据源时才显示波线
        const shouldShowWaveform = hasRealBrainwaveDataSource;
        this.$set(item, 'hideWaveform', !shouldShowWaveform);
        
        // 如果不需要显示脑波图，只隐藏图表，但不清空历史数据
        // 关键修改：不清空 waveData，保留历史数据，以便轮播回来后能继续显示
        if (!shouldShowWaveform) {
          // 只隐藏图表，但保留历史数据
          // 不清空 item.waveData，这样轮播回来后历史数据仍然存在
          const epochSnap = this.pageEpoch;
          const pageIndex = this.currentPage || 0;
          const chartId = `wave-chart-${epochSnap}-${pageIndex}-${index}`;
          const chart = this.chartInstances[chartId];
          if (chart) {
            try {
              // 只隐藏图表，不清空数据
              chart.dispose();
            } catch (e) {}
            delete this.chartInstances[chartId];
          }
          return;
        }
        
        // 立即初始化 waveData：如果有脑波值但 waveData 为空，立即添加初始数据点，确保第一次就能显示波线
        if (shouldShowWaveform) {
          if (!item.waveData) {
            item.waveData = { delta: [], theta: [], alpha: [], beta: [], gamma: [] };
          }
          // 关键修复：检查是否有脑波值但 waveData 数组为空，如果是则立即初始化
          // 但不要将 undefined 转换为 0，应该从 lastValidBrainwaveData 恢复
          const hasBrainwaveValue = (delta !== undefined && delta !== 0) || 
                                   (theta !== undefined && theta !== 0) || 
                                   (alpha !== undefined && alpha !== 0) || 
                                   (beta !== undefined && beta !== 0) || 
                                   (gamma !== undefined && gamma !== 0);
          const waveDataEmpty = !item.waveData.delta || item.waveData.delta.length === 0;
          if (hasBrainwaveValue && waveDataEmpty) {
            // 立即添加初始数据点，使用当前脑波值
            // 关键修复：如果值为 undefined，尝试从 lastValidBrainwaveData 恢复，而不是使用 0
            const timestamp = Date.now();
            ['delta', 'theta', 'alpha', 'beta', 'gamma'].forEach(type => {
              let value = item[type];
              // 如果值为 undefined 或 null，尝试从 lastValidBrainwaveData 恢复
              if ((value === undefined || value === null) && item.lastValidBrainwaveData) {
                value = item.lastValidBrainwaveData[type];
              }
              // 只有在值有效（不是 undefined 和 null）时才添加数据点
              if (value !== undefined && value !== null) {
                if (!item.waveData[type]) {
                  item.waveData[type] = [];
                }
                const dataArray = item.waveData[type];
                // 限制单条波形历史长度，防止无限增长
                const maxWaveDataLength = 1000;
                if (dataArray.length >= maxWaveDataLength) {
                  // 只保留最近的 maxWaveDataLength - 1 个点，再追加一个新点
                  dataArray.splice(0, dataArray.length - (maxWaveDataLength - 1));
                }
                dataArray.push({ value, timestamp });
              }
            });
          }
        }
        
        const timestamp = Date.now();
        
        if (item.isMock || item.dataType === 1) {
          // 检查治疗状态：只有在治疗中时才继续生成新数据
          const treatmentStatus = this.getTreatmentStatus(item);
          const isTreatmentEnded = treatmentStatus === '已结束';
          
          if (!isTreatmentEnded) {
            // 模拟数据：每秒生成新数据（仅在治疗中时）
            const newBrainwaveData = this.helpers.generateVirtualBrainwaveData(item.patientName, item.sleepState || '浅睡');
            item.delta = newBrainwaveData.delta;
            item.theta = newBrainwaveData.theta;
            item.alpha = newBrainwaveData.alpha;
            item.beta = newBrainwaveData.beta;
            item.gamma = newBrainwaveData.gamma;
            if (!item.waveData) {
              item.waveData = { delta: [], theta: [], alpha: [], beta: [], gamma: [] };
            }
            ['delta', 'theta', 'alpha', 'beta', 'gamma'].forEach(type => {
              const value = item[type] || 0;
              item.waveData[type].push({ value, timestamp });
              
              // 关键修复：当数据超过上限时，使用压缩算法压缩，而不是简单截断
              // 增加上限到5000，允许更多历史数据累积
              const maxWaveDataLength = 5000;
              const compressedLength = 2000; // 压缩后保留2000个点
              
              if (item.waveData[type].length > maxWaveDataLength) {
                // 使用压缩算法压缩数据，保留关键特征点
                const dataToCompress = item.waveData[type];
                const compressed = this.compressWaveData(dataToCompress, compressedLength);
                item.waveData[type] = compressed;
              }
            });
            const currentTime = Date.now();
            if (!item.lastSleepStateChange) {
              item.lastSleepStateChange = currentTime;
            }
            if (currentTime - item.lastSleepStateChange >= 20000) {
              const sleepStates = ['清醒', '浅睡', '深睡'];
              const currentStateIndex = sleepStates.indexOf(item.sleepState || '清醒');
              const nextStateIndex = (currentStateIndex + 1) % sleepStates.length;
              item.sleepState = sleepStates[nextStateIndex];
              item.lastSleepStateChange = currentTime;
            }
          }
          // 治疗结束后，停止生成新数据，但保留已有的 waveData
        } else {
          // 真实数据：在两次API更新之间（5秒），使用最后的数据点填充，确保每秒都有新数据点
          if (!item.waveData) {
            item.waveData = { delta: [], theta: [], alpha: [], beta: [], gamma: [] };
          }
          
          // 每秒都添加数据点，确保图表持续更新
          ['delta', 'theta', 'alpha', 'beta', 'gamma'].forEach(type => {
            const currentValue = item[type] || 0;
            const dataArray = item.waveData[type] || [];
            
            // 确定要添加的值
            let valueToAdd;
            if (currentValue !== 0) {
              // 修复波线过于平整问题：即使有脑波值，也添加小的随机波动（±2%），让波线更自然
              const variation = currentValue * 0.02;
              valueToAdd = Math.max(0, currentValue + (Math.random() - 0.5) * 2 * variation);
            } else if (dataArray.length > 0) {
              // 修复波线过于平整问题：当前值为0时，不重复使用最后一个值，而是添加小的随机波动
              // 使用最后一个值的90%-110%范围，添加自然波动
              const lastValue = dataArray[dataArray.length - 1].value || 0;
              if (lastValue > 0) {
                // 修复波线过于平整问题：增加波动幅度到±10%，让波线有更明显的起伏
                const variation = lastValue * 0.10;
                valueToAdd = Math.max(0, lastValue + (Math.random() - 0.5) * 2 * variation);
              } else {
                valueToAdd = 0;
              }
            } else {
              // 数组为空且当前值为0，使用0
              valueToAdd = 0;
            }
            
            // 添加新数据点
            item.waveData[type].push({ 
              value: valueToAdd, 
              timestamp 
            });
            
            // 限制历史数据长度
            if (item.waveData[type].length > 1000) {
              item.waveData[type] = item.waveData[type].slice(-1000);
            }
          });
        }
        
        // 修复波线穿透问题：只更新当前页面的图表
        // 使用 epoch 快照确保只更新当前世代的图表
        const chartId = `wave-chart-${epochSnap}-${currentPageIndex}-${index}`;
        const chartDom = document.getElementById(chartId);
        // epoch 校验：确保容器存在且 epoch 匹配
        if (chartDom && +chartDom.dataset.epoch === epochSnap) {
          if (this.chartInstances[chartId] || chartDom) {
            this.updateChart(index, item);
          }
        }
      });
    },
    resizeAllCharts() {
      Object.values(this.chartInstances).forEach(chart => {
        if (chart && chart.resize) {
          const tid = setTimeout(() => { chart.resize(); }, 100);
          this.chartResizeTimers.push(tid);
        }
      });
    },
    disposeAllCharts() {
      // 先清理所有实例
      Object.keys(this.chartInstances).forEach(id => {
        const chart = this.chartInstances[id];
        if (chart) {
          try {
            // 先清除图表内容
            chart.clear();
            // 然后销毁实例
            if (chart.dispose) {
              chart.dispose();
            }
          } catch (e) {
            // 忽略已销毁的实例错误
          }
        }
      });
      this.chartInstances = {};
      this.chartOptionCache = {};
      
      // 强制清理所有可能的Canvas元素，包括不在实例管理中的
      const allChartContainers = document.querySelectorAll('[id^="wave-chart-"]');
      allChartContainers.forEach(container => {
        // 清理所有Canvas元素
        const canvases = container.querySelectorAll('canvas');
        canvases.forEach(canvas => {
          try {
            // 先停止所有可能的动画
            if (canvas.getContext) {
              const ctx = canvas.getContext('2d');
              if (ctx) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
              }
            }
            canvas.remove();
          } catch (e) {
            // 忽略错误
          }
        });
        // 清空容器内容
        container.innerHTML = '';
        // 强制清理所有子节点
        while (container.firstChild) {
          try {
            container.removeChild(container.firstChild);
          } catch (e) {
            // 忽略错误
          }
        }
      });
    },
    updateChart(index, item) {
      if (this.isSliding) return;
      // 获取当前 epoch 快照，用于校验
      const epochSnap = this.pageEpoch;
      const pageIndex = this.currentPage || 0;
      const chartId = `wave-chart-${epochSnap}-${pageIndex}-${index}`;
      const chartDom = document.getElementById(chartId);
      // epoch 校验：确保容器存在且 epoch 匹配
      if (!chartDom || +chartDom.dataset.epoch !== epochSnap) {
        return;
      }
      const chart = this.chartInstances[chartId];
      // 如果图表不存在，尝试初始化（可能是在页面切换后）
      if (!chart) {
        if (chartDom && +chartDom.dataset.epoch === epochSnap) {
          const newChart = echarts.init(chartDom);
          this.chartInstances[chartId] = newChart;
          const option = this.getChartOption(item);
          this.chartOptionCache[chartId] = option;
          // 首次初始化：必须设置完整 option（含 xAxis/yAxis/grid）
          requestAnimationFrame(() => {
            if (this.pageEpoch !== epochSnap) return;
            const el = document.getElementById(chartId);
            if (!el || +el.dataset.epoch !== epochSnap) return;
            const inst = this.chartInstances[chartId];
            if (!inst || (inst.isDisposed && inst.isDisposed())) return;
            inst.setOption(option, { notMerge: true, lazyUpdate: true, silent: true });
          });
          return;
        }
        return;
      }
      // 检查治疗状态
      const treatmentStatus = this.getTreatmentStatus(item);
      const isTreatmentEnded = treatmentStatus === '已结束';
      
      // 检查历史数据是否存在
      const waveData = item.waveData || { delta: [], theta: [], alpha: [], beta: [], gamma: [] };
      const hasHistoryData = (waveData.delta && waveData.delta.length > 0) ||
                            (waveData.theta && waveData.theta.length > 0) ||
                            (waveData.alpha && waveData.alpha.length > 0) ||
                            (waveData.beta && waveData.beta.length > 0) ||
                            (waveData.gamma && waveData.gamma.length > 0);
      
      // 关键修复：检查是否有真实的脑波数据源
      // 优先级：1. 有历史数据（waveData）优先，2. 有实时数据数组，3. 有最后有效数据
      const isRealData = !item.isMock;
      const hasRealtimeDataArray = item.realtimeDataArray && Array.isArray(item.realtimeDataArray) && item.realtimeDataArray.length > 0;
      const hasValidLastValidData = item.lastValidBrainwaveData && 
                                   (item.lastValidBrainwaveData.delta > 0 || 
                                    item.lastValidBrainwaveData.theta > 0 ||
                                    item.lastValidBrainwaveData.alpha > 0 ||
                                    item.lastValidBrainwaveData.beta > 0 ||
                                    item.lastValidBrainwaveData.gamma > 0);
      
      // 检查模拟数据是否有脑波值（模拟数据只要有脑波值就显示，不需要其他条件）
      const delta = item.delta;
      const theta = item.theta;
      const alpha = item.alpha;
      const beta = item.beta;
      const gamma = item.gamma;
      const hasMockBrainwaveValues = !isRealData && (
        (delta !== undefined && delta !== null && delta > 0) ||
        (theta !== undefined && theta !== null && theta > 0) ||
        (alpha !== undefined && alpha !== null && alpha > 0) ||
        (beta !== undefined && beta !== null && beta > 0) ||
        (gamma !== undefined && gamma !== null && gamma > 0)
      );
      
      // 真实数据仅认 realtimeDataArray；虚拟数据沿用 hasHistoryData、hasValidLastValidData、hasMockBrainwaveValues
      const hasRealBrainwaveDataSource = isRealData
        ? hasRealtimeDataArray
        : (hasHistoryData || hasValidLastValidData || hasMockBrainwaveValues);
      
      // 关键修复：只有在有真实数据源时才显示波线；若无则清除波线
      if (!hasRealBrainwaveDataSource || (isTreatmentEnded && !hasHistoryData)) {
        chart.setOption({ series: [] }, { notMerge: false, replaceMerge: ['series'], lazyUpdate: true, silent: true });
        return;
      }
      
      // 如果有真实数据源，即使 hideWaveform 为 true，也要显示波线
      if (hasRealBrainwaveDataSource && item.hideWaveform) {
        // 重新设置 hideWaveform 为 false，确保波线显示
        this.$set(item, 'hideWaveform', false);
      }
      // 使用缓存的 option：少创建、多复用
      let option = this.chartOptionCache[chartId];
      if (!option) {
        option = this.getChartOption(item);
        this.chartOptionCache[chartId] = option;
      } else {
        // 只更新数据相关字段，避免频繁创建完整配置对象
        const latest = this.getChartOption(item);
        option.series = latest.series;
        option.xAxis = latest.xAxis;
      }
      // 更新阶段：只替换 series，避免闪烁；延迟到 rAF 避免 main process 警告
      requestAnimationFrame(() => {
        if (this.pageEpoch !== epochSnap) return;
        const el = document.getElementById(chartId);
        if (!el || +el.dataset.epoch !== epochSnap) return;
        const inst = this.chartInstances[chartId];
        if (!inst || (inst.isDisposed && inst.isDisposed())) return;
        inst.setOption(option, { notMerge: false, replaceMerge: ['series'], lazyUpdate: true, silent: true });
      });
    }
  }
}
</script>
